export class OperatorVehicleOwnershipDocumentsModel {
    VehicleId!: number;
    IsOwner!: boolean;
    PaOrCpcCaseNumber!: string;

    LTOOfficialReceiptImageUrl!: string;
    LTOOfficialReceiptImageUrlIsLoading: boolean = false;
    LTOOfficialReceiptExpireAt!: Date;

    CertificateRegistrationImageUrl!: string;
    CertificateRegistrationImageUrlIsLoading: boolean = false;

    SPAImageUrl!: string;
    SPAImageUrlIsLoading: boolean = false;

    ProvisionalAuthorityImageUrl!: string;
    ProvisionalAuthorityImageUrlIsLoading: boolean = false;
    ProvisionalAuthorityExpireAt!: Date;

    CertificatePublicConvenienceImageUrl!: string;
    CertificatePublicConvenienceImageUrlIsLoading: boolean = false;
    CertificatePublicConvenienceExpireAt!: Date;

    constructor(payload?: { [key: string]: any }) {
        Object.assign(this, payload);
    }
}
